import React,{ useState, useEffect } from 'react';
import {
    Button
} from 'antd';

import {
    PhoneOutlined,
    MessageOutlined,
    GoogleOutlined
} from '@ant-design/icons';

import StartCareImg from '../../images/startcareapp-react-contact2.png';

function DefaultMenu() {
    return (
        <div className='default-menu-items'>
            <div className='support-links-container startcare'>
                <h4>Fix home network issues with our self-serve app</h4>
                <p>Diagnose and troubleshoot home network issues using our self-help app, StartCARE. To find out more about the app and learn how to fix your problems faster.</p>
                <Button
                    href={"/support/startcare"}
                    type="primary"
                >Visit StartCARE Page</Button>
                <img width="206" className="startcareapp-img" src={ StartCareImg } alt="startcare app" />
            </div>
            <div className='support-team-cta-container'>
                <h4 style={{ marginBottom:"0.5rem" }}>Connect with our friendly support team</h4>
                <span style={{ display:'block', fontSize:'0.8rem', marginBottom: "1rem" }}>Available between the hours of 8:00am - 9:00pm ET</span>
                <div className='support-cta-button-container has-google-review-btn' style={{ marginBottom:'0rem' }}>
                    <div>
                        <Button
                            className="default-support-phone"
                            icon={ <PhoneOutlined /> }
                            type="default"
                            href={ "tel:1-866-434-5888" }
                            style={ { 'marginRight' : '1rem','marginBottom':'0.5rem' } }
                        > Call 1-866-434-5888</Button>
                        <Button 
                            className="live-chat-link default-support-chat"
                            type="default"
                            icon={ <MessageOutlined /> }
                        >Start a Live Chat</Button>
                    </div>
                    <div>
                        <Button 
                            className="google-review-btn"
                            style={{ marginLeft: 'auto', backgroundColor: '#fff', color:"#1C4A12" }}
                            type="primary"
                            href={ "https://g.page/r/CWvpWxOCQQ84EAI/review" }
                            icon={ <GoogleOutlined /> }
                        >Leave us a review!</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DefaultMenu
